import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';

import { CardModule } from 'primeng/card';
import { GalleriaModule } from 'primeng/galleria';
import { RippleModule } from 'primeng/ripple';



// Application Components
import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { AppMenuComponent } from './app.menu.component';
import { AppMenuitemComponent } from './app.menuitem.component';
import { AppProfileComponent } from './app.profile.component';
import { AppTopBarComponent } from './app.topbar.component';

// Demo pages
import { AppAccessdeniedComponent } from './pages/app.accessdenied.component';
import { AppErrorComponent } from './pages/app.error.component';
import { AppNotfoundComponent } from './pages/app.notfound.component';

// Application services
import { ActivatedRoute } from '@angular/router';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { JoyrideModule } from 'ngx-joyride';
import { MessageService, SharedModule } from 'primeng/api';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';
import { AccordionModule } from 'primeng/accordion';
import { GENERAL_EN } from '../assets/i18n/en';
import { GENERAL_ES } from '../assets/i18n/es';
import { environment } from '../environments/environment';
import { MenuService } from './app.menu.service';
import { WizardLoaderComponent } from './components/loader/loader.component';
import { CustomTranslationLoader } from './custom-translate-loader';
import { FeatureEnablerDirective } from './directives/feature-enabler/feature-enabler.directive';
import { PhotoService } from './modules/public/buildings-detail/photoservice';
import { TrackService } from './services/track.service';
import { CacheInterceptor } from './interceptors/intercerptor/cache.interceptor';
import { EmptyComponent } from './modules/public/empty/empty.component';

@NgModule({
    imports: [
        SharedModule,
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        CardModule,
        GalleriaModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomTranslationLoader,
                deps: [HttpClient]
            }
        }),
        RippleModule,
        BadgeModule,
        ToastModule,
        AccordionModule,
        DialogModule,
        ProgressBarModule,
        ButtonModule,
        MessageModule,
        InputTextModule,
        FileUploadModule,
        JoyrideModule.forRoot(),
        AngularEditorModule
    ],
    declarations: [
        FeatureEnablerDirective,
        EmptyComponent,
        AppComponent,
        AppMainComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        AppTopBarComponent,
        AppProfileComponent,
        AppNotfoundComponent,
        AppErrorComponent,
        AppAccessdeniedComponent,
        WizardLoaderComponent
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
        MenuService,
        MessageService,
        PhotoService
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    bootstrap: [AppComponent],

})
export class AppModule {

    constructor(
        private readonly translateService: TranslateService,
        private readonly activatedRoute: ActivatedRoute,
        private readonly trackService: TrackService
    ) {
        if (environment.production) {
            if (location.protocol === 'http:') {
              window.location.href = location.href.replace('http', 'https');
            }
        }
        this.activatedRoute.queryParams.subscribe((params) => {
            this.trackService.trackVisit(params);
        });
        this.translateService.onLangChange.subscribe((event) => {
            localStorage.setItem('lang', event.lang);
            const langTranslations = {
                'en': [GENERAL_EN],
                'es': [GENERAL_ES]
            }
            langTranslations[selectedLanguage].forEach((translation) => {
                this.translateService.setTranslation(selectedLanguage, translation, true);
            });
        });
        let selectedLanguage = localStorage.getItem('lang') || this.getNavigatorLang();
        selectedLanguage = 'es';
        localStorage.setItem('lang', selectedLanguage);
        this.translateService.use(selectedLanguage);
    }

    getNavigatorLang(): string {
        let lang = navigator.language;
        if (lang.includes('es')) {
            return 'es';
        } else {
            return 'en';
        }
    }
}
